import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { CheckboxWidget, ObjectListWidget } from '@plone/volto/components';

import { SizeWidget } from 'iovisit-theme/components';

const messages = defineMessages({
  size: {
    id: 'Size',
    defaultMessage: 'Dimensione',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Titolo',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Descrizione',
  },
  logo: {
    id: 'Logo',
    defaultMessage: 'Logo',
  },
  logo_description: {
    id: 'MultimediaBlock_Logo',
    defaultMessage: "Aggiungi un logo o un'icona di fianco al titolo.",
  },
  image: {
    id: 'Image',
    defaultMessage: 'Immagine',
  },
  image_description: {
    id: 'MultimediaBlock_Image description',
    defaultMessage:
      "Se viene selezionato un video, questa sarà l'immagine di copertina che verrà mostrata finchè il video non sarà stato caricato. Se non viene selezionato nessun video, questa sarà l'immagine di sfondo della slide.",
  },
  buttonText: {
    id: 'MultimediaBlock_Testo sul bottone',
    defaultMessage: 'Testo sul bottone',
  },
  buttonTextDescription: {
    id: 'MultimediaBlock_Testo sul bottone description',
    defaultMessage:
      "Se presente, verrà mostrato un bottone che al click porterà alla destinazione scelta nel campo 'Destinazione'. Se non compilato, il link verrà posizionato sul titolo della slide",
  },
});

const Sidebar = (props) => {
  const intl = useIntl();
  const { data, block, onChangeBlock } = props;

  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage
            id="MultimediaBlock"
            defaultMessage="Blocco Multimedia"
          />
          :
        </h2>
      </header>

      <Segment className="form sidebar-listing-data">
        {/* <CheckboxWidget
          id="leadimage"
          title="Mostra nella testata della pagina"
          value={data.leadimage ? data.leadimage : false}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        /> */}
        <CheckboxWidget
          id="autoplay"
          title="Autoplay"
          value={data.autoplay ? data.autoplay : false}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
        <CheckboxWidget
          id="fullwidth"
          title="A tutta larghezza"
          value={data.fullwidth ? data.fullwidth : false}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />

        <SizeWidget
          id="size"
          title={intl.formatMessage(messages.size)}
          value={data.size || 'l'}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
      </Segment>

      <ObjectListWidget
        {...props}
        id="slides"
        value={data?.slides ?? []}
        onChange={(id, value) => {
          props.onChangeBlock(block, { ...data, [id]: value });
        }}
        schema={() => {
          return {
            title: 'Slide',
            addMessage: 'Aggiungi una Slide',
            fieldsets: [
              {
                id: 'default',
                title: 'Default',
                fields: [
                  'title',
                  'description',
                  'logo_icon',
                  'image',
                  'video',
                  'href',
                  'href_title',
                ],
              },
            ],
            properties: {
              title: {
                title: intl.formatMessage(messages.title),
              },
              description: {
                title: intl.formatMessage(messages.description),
              },
              logo_icon: {
                title: intl.formatMessage(messages.logo),
                description: intl.formatMessage(messages.logo_description),
                widget: 'object_browser',
                mode: 'image',
                allowExternals: false,
              },
              image: {
                title: intl.formatMessage(messages.image),
                description: intl.formatMessage(messages.image_description),
                widget: 'object_browser',
                mode: 'image',
                allowExternals: false,
              },
              video: {
                title: 'Video',
                widget: 'object_browser',
                mode: 'video',
                widgetOptions: {
                  pattern_options: {
                    selectableTypes: ['File'],
                    maximumSelectionSize: 1,
                  },
                },
                allowExternals: false,
              },
              href: {
                title: 'Link',
                widget: 'object_browser',
                mode: 'link',
                allowExternals: true,
              },
              href_title: {
                title: intl.formatMessage(messages.buttonText),
                description: intl.formatMessage(messages.buttonTextDescription),
              },
            },

            required: [],
          };
        }}
      />
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  onChangeSubblocks: PropTypes.func.isRequired,
  openObjectBrowser: PropTypes.func.isRequired,
};

export default Sidebar;
